@if (schema$ | async; as currSchema) {
<div
  class="app-lang"
  nz-popover
  nzPopoverTrigger="click"
  [nzPopoverPlacement]="['bottomRight', 'topRight', 'bottomLeft', 'bottomRight']"
  [nzPopoverVisible]="popoverVisible"
  [nzPopoverContent]="contentTemplate"
  (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
  data-cy="language-switch"
>
  <app-image [name]="icon" [text]="currSchema.text"></app-image>
  <ng-template #contentTemplate>
    @if (schemas$ | async; as schemas) {
    <div class="app-lang-popover-container app-lang-popover-container{{schemas.length > 7 ? '-double' : ''}}" dir="ltr">
      <ul>
        @for (schema of schemas; track schema.locale.language) { @if (schema !== currSchema) {
        <li class="app-lang-popover-item">
          <a class="app-lang-popover-item-link" (click)="setSchema(schema)">{{ schema.text }}</a>
        </li>
        } }
      </ul>
    </div>
    }
  </ng-template>
</div>
}
